export const LIGHT_COLOR_ARR = ['#5086F3', '#69D19C', '#6E7794', '#F8D74D', '#7F6FF1', '#5EC8F1', '#AD53D4', '#F19E55', '#488E89', '#F17C86', '#709FFF', '#45AF6A', '#9AA5C9', '#BE9737', '#9C8CEE', '#3EAFD7', '#E171BD', '#CE8038', '#6BB1AF', '#E5727C', '#ABD2FF', '#78E198', '#CDD8FD', '#F3C866', '#D4C0FF', '#7BE2FF', '#FFA7F3', '#FBB167', '#9EE5E2', '#FFAAB3', '#D4E8FF', '#92FBB0', '#E5EBFD', '#FFE683', '#F1DCFF', '#99FEFF', '#FFCAFF', '#FFD286', '#B9FFFE', '#FFCAD2'];
export const DARK_COLOR_ARR = ['#5086F3', '#69D19C', '#6E7794', '#F8D74D', '#7F6FF1', '#5EC8F1', '#AD53D4', '#F19E55', '#488E89', '#F17C86', '#709FFF', '#45AF6A', '#9AA5C9', '#BE9737', '#9C8CEE', '#3EAFD7', '#E171BD', '#CE8038', '#6BB1AF', '#E5727C', '#ABD2FF', '#78E198', '#CDD8FD', '#F3C866', '#D4C0FF', '#7BE2FF', '#FFA7F3', '#FBB167', '#9EE5E2', '#FFAAB3', '#D4E8FF', '#92FBB0', '#E5EBFD', '#FFE683', '#F1DCFF', '#99FEFF', '#FFCAFF', '#FFD286', '#B9FFFE', '#FFCAD2'];
export const EXTENSION_STYLE = 'position: absolute;z-index: 99999;color: #fff;font-size: 12px;padding: 5px;display: inline;border-radius: 4px;background-color: #303133;box-shadow: rgba(0, 0, 0, 0.3) 2px 2px 8px';
export const EVENT_COLOR_ARR = ['#5086F3', '#77E097', '#6E7794', '#F8D74D', '#7F6FF1', '#5EC8F1', '#AD53D4', '#F19E55', '#488E89', '#F17C86'];

export const LIGHT_RGBA_COLORS = [
  'rgba(80, 134, 243, 1)',
  'rgba(105, 209, 156, 1)',
  'rgba(110, 119, 148, 1)',
  'rgba(248, 215, 77, 1)',
  'rgba(127, 111, 241, 1)',
  'rgba(94, 200, 241, 1)',
  'rgba(173, 83, 212, 1)',
  'rgba(241, 158, 85, 1)',
  'rgba(72, 142, 137, 1)',
  'rgba(241, 124, 134, 1)',
  'rgba(112, 159, 255, 1)',
  'rgba(69, 175, 106, 1)',
  'rgba(154, 165, 201, 1)',
  'rgba(190, 151, 55, 1)',
  'rgba(156, 140, 238, 1)',
  'rgba(62, 175, 215, 1)',
  'rgba(225, 113, 189, 1)',
  'rgba(206, 128, 56, 1)',
  'rgba(107, 177, 175, 1)',
  'rgba(229, 114, 124, 1)',
  'rgba(171, 210, 255, 1)',
  'rgba(120, 225, 152, 1)',
  'rgba(205, 216, 253, 1)',
  'rgba(243, 200, 102, 1)',
  'rgba(212, 192, 255, 1)',
  'rgba(123, 226, 255, 1)',
  'rgba(255, 167, 243, 1)',
  'rgba(251, 177, 103, 1)',
  'rgba(158, 229, 226, 1)',
  'rgba(255, 170, 179, 1)',
  'rgba(212, 232, 255, 1)',
  'rgba(146, 251, 176, 1)',
  'rgba(229, 235, 253, 1)',
  'rgba(255, 230, 131, 1)',
  'rgba(241, 220, 255, 1)',
  'rgba(153, 254, 255, 1)',
  'rgba(255, 202, 255, 1)',
  'rgba(255, 210, 134, 1)',
  'rgba(185, 255, 254, 1)',
  'rgba(255, 202, 210, 1)'
];

export const CompareText = {
  empty: '',
  compare: '对比项',
  compare1: '对比项一',
  compare2: '对比项二',
};
export const ColorStartIndex = {
  [CompareText.empty]: 0,
  [CompareText.compare1]: 0,
  [CompareText.compare2]: 20,
};

export const LEGEND2_SYMBOL = '@';
export const DATALAB_TOTAL_KEY = '@@DATALAB_TOTAL@@';
// 默认富文本配置（集中管理默认样式）
export const DEFAULT_RICH_CONFIG = {
  fontSize: 12,
  color: '#262832'
};
// 位置反转映射表（提取为常量，避免重复创建）
export const REVERSE_POSITION_MAP: Record<string, string> = {
  top: 'bottom',
  bottom: 'top',
  left: 'right',
  right: 'left',
  center: 'center',
  insideTop: 'insideBottom',
  insideBottom: 'insideTop',
};